/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VirtualHealthLibraryStrictHttpResponse } from '../../virtual-health-library-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleReadRequest } from '../../models/article-read-request';

export interface AiArticleReadPost$Params {
      body?: ArticleReadRequest
}

export function aiArticleReadPost(http: HttpClient, rootUrl: string, params?: AiArticleReadPost$Params, context?: HttpContext): Observable<VirtualHealthLibraryStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, aiArticleReadPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as VirtualHealthLibraryStrictHttpResponse<void>;
    })
  );
}

aiArticleReadPost.PATH = '/AI/ArticleRead';
